
webpack.register(
    'modules/department/informational-hub/informational-hub',
    function() {
        return import('modules/department/informational-hub/informational-hub');
    },
    true
);